/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TenantApi } from '../api/tenant.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantData, Tenant } from '../../../interfaces/masters/tenant';
//import { Tenant } from '../../../interfaces/masters/tenant';

@Injectable()
export class TenantService extends TenantData {

  constructor(private api: TenantApi) {
    super();
  }

  list(url: string): Observable<Tenant[]> {
    return this.api.list(url);
  }
  validateCustomerByHostName(url: string): Observable<Tenant[]> {
    return this.api.validateCustomerByHostName(url);
  }
  getById(url:string): Observable<Tenant>{
      return this.api.getById(url);
  }
  getCustomerId(url:string): Observable<Tenant>{
    return this.api.getCustomerId(url);
  }

  create(url: string, data:Tenant): Observable<Tenant> {
    return this.api.add(url,data);
  }
  createAccount(url: string, data:any): Observable<any> {
    
    return this.api.addAccount(url,data);
  }
  search(url: string, data:any): Observable<Tenant> {
    return this.api.add(url,data);
  }
  getTenantData(url: string, data:Tenant): Observable<Tenant> {
    return this.api.search(url,data);
  }

  update(url: string, data:Tenant): Observable<Tenant> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  

}
